<div class="page-header">
  <app-prev-next-button direction="left" label="Expedição" (click)="goToExpedition()"></app-prev-next-button>
  <h1>Ordens de Venda Completadas</h1>
</div>
<div class="ctrl-bar">
  <div class="buttons">
    <div class="update-button">
      <p>Atualizado às {{ actualHour }}</p>
      <button mat-raised-button (click)="update()">
        <i class="uil uil-sync"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </div>
</div>
<app-side-color-card color="primary-1">
  <div content class="card-content">
    <div class="card-header">
      <h2>Ordens de venda ({{ sellOrdersService.totalItems$ | async | number:'1.0-0':'pt-BR' }})</h2>
      <div class="paginator-container">
        <app-paginator
          [currentPage]="sellOrdersService.currentPage$ | async"
          [pageCount]="sellOrdersService.pageCount$ | async"
          [atFirstPage]="sellOrdersService.atFirstPage$ | async"
          [atLastPage]="sellOrdersService.atLastPage$ | async"
          [pageSize]="sellOrdersService.pageSize$ | async"
          [pageSizeOptions]="sellOrdersService.pageSizeOptions$ | async"
          (nextPage)="getNextPage()"
          (previousPage)="getPreviousPage()"
          (pageSizeChange)="onPageSizeChange($event)"
          (pageChange)="onPageChange($event)"
        ></app-paginator>
      </div>
    </div>
    <div class="table">
      <app-sell-orders-table
        [sellOrders]="data"
        (clicked)="onSellOrderClicked($event)"
        (onFilterValuesChange)="onFiltersApply($event)">
      </app-sell-orders-table>
      <div *ngIf="isLoading" class="loader">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <div class="empty" *ngIf="data?.length === 0 && !isLoading">
        NÃO EXISTEM ORDENS DE VENDA COMPLETADAS.
      </div>
    </div>
  </div>
</app-side-color-card>

<app-full-page-loader *ngIf="isModalLoading"></app-full-page-loader>
